var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-tab",
    { attrs: { tab: _vm.tab } },
    [
      _c(
        "w-scroll-view",
        { style: { height: "100%" } },
        [
          _vm.tab == 0
            ? _c("app-page-settings", { attrs: { layout: _vm.layout } })
            : _vm._e(),
          _vm.tab == 1
            ? _c("app-heading-settings", {
                attrs: {
                  "contact-group-id": _vm.contactGroupId,
                  layout: _vm.layout,
                  "full-control": _vm.fullControl,
                },
                on: {
                  "open-free-block": function ($event) {
                    return _vm.onOpenFreeBlock($event)
                  },
                },
              })
            : _vm._e(),
          _vm.tab == 2
            ? _c("app-text-settings", {
                attrs: { settings: _vm.layout.TextSettings },
              })
            : _vm._e(),
          _vm.tab == 3
            ? _c("app-logo-settings", {
                attrs: {
                  "full-control": _vm.fullControl,
                  logos: _vm.layout.Logos,
                  layout: _vm.layout,
                },
              })
            : _vm._e(),
          _vm.tab == 4
            ? _c("app-table-line-settings", {
                attrs: {
                  line: _vm.layout.TitleLine,
                  title: _vm.$ct("titleLine"),
                },
              })
            : _vm._e(),
          _vm.tab == 5
            ? _c("app-table-line-settings", {
                attrs: {
                  line: _vm.layout.DateLine,
                  title: _vm.$ct("dateLine"),
                },
              })
            : _vm._e(),
          _vm.tab == 6
            ? _c("app-detail-settings", {
                attrs: { "full-control": _vm.fullControl, layout: _vm.layout },
              })
            : _vm._e(),
          _vm.tab == 7
            ? _c("app-totals-settings", { attrs: { layout: _vm.layout } })
            : _vm._e(),
          _vm.tab == 13
            ? _c("app-vat-settings", {
                attrs: { lines: _vm.layout.TotalLines },
              })
            : _vm._e(),
          _vm.tab == 8
            ? _c("app-free-lines", { attrs: { layout: _vm.layout } })
            : _vm._e(),
          _vm.tab == 9
            ? _c("app-free-blocks-settings", {
                attrs: {
                  blocks: _vm.layout.FreeBlocks,
                  layout: _vm.layout,
                  "init-to-edit-free-block": _vm.toEditFreeBlock,
                },
              })
            : _vm._e(),
          _vm.tab == 10
            ? _c("app-requirement-settings", {
                attrs: { requirements: _vm.layout.Requirements },
              })
            : _vm._e(),
          _vm.tab == 11
            ? _c("app-attachment-settings", { attrs: { settings: _vm.layout } })
            : _vm._e(),
          _vm.tab == 12
            ? _c("app-pdf-preview", { attrs: { layout: _vm.layout } })
            : _vm._e(),
          _vm.tab == 14
            ? _c("app-qr-settings", {
                attrs: {
                  "client-portal-qr-settings":
                    _vm.layout.ClientPortalQrSettings,
                  "payment-qr-settings": _vm.layout.PaymentQrSettings,
                  layout: _vm.layout,
                },
              })
            : _vm._e(),
          _vm.tab == 15
            ? _c("app-barcode-settings", { attrs: { layout: _vm.layout } })
            : _vm._e(),
          _vm.tab == 16
            ? _c("app-payment-settings", { attrs: { layout: _vm.layout } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }